import { render, staticRenderFns } from "./ScoreAsdas.vue?vue&type=template&id=16d51fba&scoped=true"
import script from "./ScoreAsdas.vue?vue&type=script&lang=js"
export * from "./ScoreAsdas.vue?vue&type=script&lang=js"
import style0 from "./ScoreAsdas.vue?vue&type=style&index=0&id=16d51fba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d51fba",
  null
  
)

export default component.exports